export enum ShadowsSize {
  small = 'small',
  medium = 'medium',
  large = 'large',
  xLarge = 'xLarge',
  focusState = 'focusState',
}

export const shadows = {
  sizes: {
    small:
      '0px 6px 6px -6px rgba(0, 0, 0, 0.16), 0px 0px 1px 0px rgba(0, 0, 0, 0.40)',
    medium:
      '0px 12px 12px -6px rgba(0, 0, 0, 0.16), 0px 0px 1px 0px rgba(0, 0, 0, 0.40)',
    large:
      '0px 8px 24px -6px rgba(0, 0, 0, 0.16), 0px 0px 1px 0px rgba(0, 0, 0, 0.40)',
    xLarge:
      'box-shadow: 0px 32px 32px -8px rgba(0, 0, 0, 0.08), 0px 0px 32px -8px rgba(0, 0, 0, 0.12), 0px 0px 1px 0px rgba(0, 0, 0, 0.20);',
    focusState: '0px 0px 0px 4px #D8EFEB',
  },
};
